export const formatServiceData = (event: any) => {
  const products = [
    ...(event?.data.usedProducts ?? []),
    ...(event?.data.sevdeskProducts ?? []),
  ];
  const images = event?.includes?.documents ?? [];

  return { products, images };
};
